import { RuntimeEntryScreen } from '@/features/unified-learning/runtime/screens/RuntimeEntryScreen';

export default function LearnPathEntryRoute() {
  return <RuntimeEntryScreen runtimeBase="/learn/path" />;
}
